import React from "react";
import {Box, Button} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {ConfigDto} from "../../flippingFlyersCatalog/flippingFlyerTocTab";
import {ReactComponent as ArrowUp} from "../../../assets/editors/spots/arrow_up_icon.svg";
import {ReactComponent as ArrowDown} from "../../../assets/editors/spots/arrow_down_icon.svg";
import {ReactComponent as ArrowUpDown} from "../../../assets/up_down_icon.svg";

const useStyle = makeStyles(() => ({
    sortButton: {
        "&.MuiButton-root": {
            display: "flex",
            alignItems: "center",
            cursor: "pointer"
        }
    },
    doubleArrowSortBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "20px",
        height: "20px"
    },

}))


interface Props {
    sortCaption: string;
    items: any[];
    setSortConfig: (data: ConfigDto) => void;
    sortConfig: ConfigDto | null
}

export const SortBtn: React.FC<Props> = ({
                                             sortCaption,
                                             items,
                                             setSortConfig,
                                             sortConfig
                                         }) => {
    const classes = useStyle();

    const getClassNamesFor = (name: string) => {
        if (!sortConfig) {
            return;
        }
        return sortConfig.caption === name ? sortConfig.direction : undefined;
    };

    const requestSort = (caption: string) => {
        let direction = 'ascending';
        if (
            sortConfig &&
            sortConfig.caption === caption &&
            sortConfig.direction === 'ascending'
        ) {
            direction = 'descending';
        }
        setSortConfig({caption, direction});
    };


    return (
        <Button
            disabled={items.length === 0}
            className={classes.sortButton}
            onClick={() => {
                requestSort(sortCaption)
            }}
        >
            {
                !getClassNamesFor(sortCaption) &&
                <Box className={classes.doubleArrowSortBox}>
                    <ArrowUpDown/>
                </Box>
            }
            {
                getClassNamesFor(sortCaption) === "descending" &&
                <ArrowUp/>
            }

            {
                getClassNamesFor(sortCaption) === "ascending" &&
                <ArrowDown/>
            }
        </Button>
    )
}